// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationListItem } from "../../../../components/ApplicationList";
import { jsx as _jsx } from "react/jsx-runtime";
export const ComponentListItem = props => {
  const {
    identifiant,
    nom,
    defaut,
    selected,
    onClick
  } = props;
  const handleClick = React.useCallback(() => {
    onClick?.({
      identifiant,
      nom
    });
  }, [identifiant, nom, onClick]);
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationListItem, {
    icon: defaut && "tag",
    content: nom,
    selected: selected,
    onClick: handleClick
  }), [nom, defaut, selected, handleClick]);
};